var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhatsappRedesign(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 66.899,
    height: 67.215,
    viewBox: "0 0 66.899 67.215",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#78cd51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#a0fc84"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.5,
    y1: 0.927,
    x2: 0.5,
    y2: -0.073,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#78cd51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a0fc84"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(0 -0.02)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Graphic_Elements",
    "data-name": "Graphic Elements",
    transform: "translate(0 0.02)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15904",
    "data-name": "Rectangle 15904",
    width: 25.642,
    height: 6.63,
    transform: "translate(6.833 53.549)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_638",
    "data-name": "Ellipse 638",
    cx: 31.097,
    cy: 31.097,
    r: 31.097,
    transform: "translate(1.541 2.545)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "WA_Logo",
    "data-name": "WA Logo"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_65753",
    "data-name": "Path 65753",
    d: "M57.175,9.771A33.331,33.331,0,0,0,4.724,49.966L0,67.234l17.665-4.669A33.276,33.276,0,0,0,33.588,66.62h0A33.323,33.323,0,0,0,57.175,9.771ZM33.6,61.024h0a27.665,27.665,0,0,1-14.1-3.891l-1.012-.607L8,59.32,10.8,49.1l-.685-1.051A27.7,27.7,0,1,1,33.6,61.024ZM48.794,40.293c-.833-.42-4.926-2.436-5.689-2.708s-1.315-.42-1.875.412S39.082,40.7,38.6,41.25s-.973.623-1.805.2a22.661,22.661,0,0,1-6.7-4.093,25.292,25.292,0,0,1-4.669-5.767c-.482-.833-.047-1.284.366-1.7s.833-.973,1.253-1.455a5.852,5.852,0,0,0,.833-1.385,1.556,1.556,0,0,0-.07-1.463c-.21-.412-1.875-4.514-2.568-6.179s-1.362-1.4-1.875-1.432-1-.07-1.572-.07a3.051,3.051,0,0,0-2.218,1.035,9.339,9.339,0,0,0-2.918,6.949c0,4.093,2.988,8.055,3.4,8.607S25.93,43.46,34.28,47.063a49.37,49.37,0,0,0,4.747,1.759,11.51,11.51,0,0,0,5.245.327c1.6-.241,4.926-2.016,5.619-3.961a6.921,6.921,0,0,0,.482-3.953C50.164,40.892,49.627,40.7,48.794,40.293Z",
    transform: "translate(0 -0.02)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsappRedesign);
export default __webpack_public_path__ + "static/media/whatsapp-redesign.c254b2f4c039fbb6860b3c48f2380285.svg";
export { ForwardRef as ReactComponent };